import React, { useEffect, useRef, useCallback, forwardRef } from 'react';
import { OFFSET } from "@/finsight/ui/components/static/Catalog/CatalogList/constants";
import { isScreenXs } from "@dealroadshow/uikit/core/styles/screen/screen";

import styles from './catalogList.scss';

interface IProps {
  onScroll: ({ currentTarget }: { currentTarget: Partial<HTMLDivElement> }) => void,
  style: React.CSSProperties,
  children: React.ReactNode,
}

const CatalogListOuterComponent = forwardRef(({
    onScroll,
    style: { height, ...style},
    children,
  }: IProps, reactWindowRef: React.ForwardedRef<HTMLDivElement>) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const isMobile = isScreenXs();

  const refSetter = useCallback(
    (scrollbarsRef: HTMLDivElement) => {
      if (typeof reactWindowRef === 'function') {
        if (scrollbarsRef) {
          reactWindowRef(scrollbarsRef);
          containerRef.current = scrollbarsRef;
        } else {
          reactWindowRef(null);
          containerRef.current = null;
        }
      }
    },
    [reactWindowRef]
  );

  const handleScroll = useCallback(() => {
    const scrollTop = window.scrollY;
    const scrollLeft = window.scrollX;
    const clientHeight = window.innerHeight;
    const clientWidth = window.innerWidth;
    const { scrollHeight, scrollWidth } = document.body;

    const containerTopPosition = containerRef.current?.getBoundingClientRect().top;

    onScroll({
      currentTarget: {
        clientHeight,
        clientWidth,
        scrollLeft,
        scrollTop: scrollTop - (containerRef.current ? containerTopPosition + scrollTop : 0),
        scrollHeight,
        scrollWidth,
      },
    });
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', handleScroll);

    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div
      className={ styles.outerElement }
      style={ { ...style, overflow: 'visible', paddingTop: isMobile ? 0 : OFFSET } }
      ref={ refSetter }
    >
      { children }
    </div>
  );
});

export default CatalogListOuterComponent;
